import { render, staticRenderFns } from "./productos_helloteca.vue?vue&type=template&id=4a481aff&scoped=true"
import script from "./productos_helloteca.vue?vue&type=script&lang=js"
export * from "./productos_helloteca.vue?vue&type=script&lang=js"
import style0 from "./productos_helloteca.vue?vue&type=style&index=0&id=4a481aff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a481aff",
  null
  
)

export default component.exports